<template>
	<div class="page-mdl">
		
		<m-second :datas="secondInfo" @changeNav="changeNav">
			<div class="news-box">
				<ul class="news-list" v-if="listInfo.list.length>0">
					<li v-for="(item,index) in listInfo.list" :key="item.contentId" @click="goDetail(item.contentId)">
						<div class="title">{{item.contentTitle}}</div>
						<div class="date">{{item.createdDt.substring(0,10)}}</div>
					</li>
				</ul>
				<van-empty v-if=" !listInfo.list.length>0"  description="没找到相应内容" />
				<!-- 分页 -->
				<div class="paging" v-if="listInfo.pagingList.length>1">
					<span class="prev" @click="changePaging(listInfo.pageNum-1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
					<span :class="{active:index==listInfo.pageNum-1}" v-for="(item,index) in listInfo.pagingList" :key="index" 
						@click="changePaging(item,'listInfo')">{{item}}</span>
					<span class="next" @click="changePaging(listInfo.pageNum+1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
				</div>
			</div>
		</m-second>

	</div>
</template>

<script>
import mSecond from '@/components/second.vue'
export default {
	name: 'newsList',
	components:{
		mSecond
	},
	data () {
		return {
			firstCateId:'',	//栏目id
			secondInfo:{
				title:'',
				list:[
					// { title:'新闻动态',  },
					// { title:'政策文件',  }
				],
				columnId:''
			},
			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:10,
				total:0,
				pagingList:[],
			},
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.firstCateId = this.$route.params.firstCateId
		this.getSecondColumnList()
		this.getColumnTitle()
	},
  
	
	watch:{
		$route(to,from){
			this.firstCateId = to.params.firstCateId
			this.getSecondColumnList()
			this.getColumnTitle()
		},
	},
  
	methods:{
		//获取一级栏目名称
		getColumnTitle(){
			const { navList } = this.$store.state
			let { firstCateId } = this
			let parentName = ''
			navList.forEach(item=>{
				if(item.columnId == firstCateId){
					parentName = item.columnName
				}
			})
			this.secondInfo.title = parentName
			this.$store.commit('changeNavId',firstCateId)
		},

		//查询二级栏目
		getSecondColumnList(){
			let { firstCateId } = this
			//获取二级栏目列表
			this.$axios({
				url:`/jxedu/api/site/secondColumnList/${firstCateId}`,
			}).then(res=>{
				let list = res.data
				let infoList = []
				list.forEach((item,index)=>{
					infoList.push({
						title:item.columnName,
						columnId:item.columnId
					})
				})
				this.secondInfo.list = infoList
				const { secondCateId } = this.$route.query	
				this.secondInfo.columnId = secondCateId || infoList[0].columnId
				this.getNewList()
			})
		},
		
		//查询门户首页二级栏目数据
		getNewList(){
			const {  pageSize, pageNum } = this.listInfo
			const { columnId } = this.secondInfo
			this.$axios({
				url:`/jxedu/api/site/columnContents`,
				params:{
					columnId,
					pageNum,
					pageSize
				}
			}).then(res=>{
				let list = res.data.rows
				let total = res.data.total
				
				let num = Math.ceil(total/pageSize)
				let pagingList = []
				if(num>0){
					for(var i=0; i<num; i++){
						pagingList.push(i+1)
					}
				}else{
					pagingList.push(1)
				}
				this.listInfo.list = list
				this.listInfo.total = total
				this.listInfo.pagingList = pagingList
			})
		},
		
		//切换分页
		changePaging(num,obj){
			const { pageNum, pagingList } = this[obj]
			if(num < 1 || num > pagingList.length || pageNum == num){
				return
			}
			this[obj].pageNum = num
			switch(obj){
				case 'listInfo':  //开放课堂
					this.getNewList();
					break;
			}
		},

		
		//跳转新闻详情
		goDetail(contentId){
			this.goUrl({name:'newsDetail',params:{ id:contentId }, query:{ parentId : this.secondInfo.columnId }})
		},
		
		//改变左侧菜单栏
		changeNav(columnId){
			//this.secondInfo.columnId = columnId 
			this.goUrl({ name:'news',params:{ id:this.firstCateId },query:{ secondCateId: columnId}})
			//this.getNewList()
		}
		
	}
}
</script>

<style lang="less" scoped>
.news-list{
	padding:0 140px 0 72px;
	li{
		height: 48px; display: flex; align-items: center;  cursor: pointer; transition:all .2s;
		padding:0 12px 0 20px; border-bottom:1px dashed #D8DADD; position:relative;
		&::before{
		  content:''; display:inline-block; width:6px; height:6px; background:#D8DADD; 
		  position:absolute; left:0; top:50%; margin-top:-3px; border-radius:100%;
		}
		.date{ font-size:14px; color:#999999; width:120px; text-align: right;}
		.title{ 
			flex:1; font-size: 14px; color:#333; font-weight: bold;
			display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 1;
		}
	}
	li:hover{ 
		box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.08);
		.title{ color: #1677FF;}
	}
}
.more-btn{display:none; text-align:center; font-size:14px; color:#007AFF; padding:10px 0;}
</style>



// WEBPACK FOOTER //
// src/pages/news-list/tpl-pc.vue